// extracted by mini-css-extract-plugin
export var container = "OrderSummary_container__dH3fx";
export var footnote = "OrderSummary_footnote__YcDJP";
export var shippingCost = "OrderSummary_shippingCost__R6wnm";
export var shippingCostContainer = "OrderSummary_shippingCostContainer__76kP1";
export var sum = "OrderSummary_sum__rIB5N";
export var title = "OrderSummary_title__UuH-G";
export var total = "OrderSummary_total__fAW++";